module.exports = __webpack_public_path__ + "assets/create-class-no-bg.c27f6943.svg";